import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SurveyTypes } from '../models/surveytypes';
import { VisionService } from '../services/vision.service';
import { JobService } from '../services/job.service';
import { CriteriaService } from '../services/criteria.service';
import { User } from '../models/dto/user';
import { SurveyDetails } from '../models/dto/survey';
import * as Rx from 'rxjs/Rx';

@Injectable()
export class VisionModel {
    email: string;
    user_data: any;
    vision_title: string;
    user_surveys: Array<SurveyDetails> = [];

    constructor(private visionService: VisionService, private surveyTypes: SurveyTypes, private jobService: JobService,
        private criteriaService: CriteriaService) {
        const user = JSON.parse(localStorage.getItem('user_data'));
        const user_id = user.id;
        this.email = user.email;
    }

    visionIsExist(visionType: number) {
        this.vision_title = this.surveyTypes.getTitle(visionType);  // selected text
        return this.visionService.getUserVisions(this.email).map(result => {
            this.user_data = result.User;
            if (this.user_data.surveys) {
                const isExist = this.user_data.surveys.filter(x => x.title === this.vision_title)[0];
                if (isExist) {
                    return true;
                } else {
                    return false;
                }
            }
        });
    }

    setSurveysInStorage(newVision: SurveyDetails) {
        this.email = localStorage.getItem('email');
        this.visionService.getUserVisionsCriterias(this.email).subscribe(result => {
            if (newVision) {
                this.user_surveys.push(newVision);
            }
            localStorage.setItem('surveys', JSON.stringify(this.user_surveys));
        });
    }

    getCurrentSurveyTypeId() {
        const surveyTitle = localStorage.getItem('vision_title');
        const surveyTypeId = this.surveyTypes.getTitleId(surveyTitle);  // selected vision
        return surveyTypeId;
    }

    setSurveyInStorageFromType(visionType: number) {
        this.vision_title = this.surveyTypes.getTitle(visionType);  // selected text
        return this.visionService.getUserVisionsCriterias(this.email).map(result => {
            this.user_data = result.User;
            if (this.user_data.surveys) {
                const isExist = this.user_data.surveys.filter(x => x.title === this.vision_title)[0];
                if (isExist) {
                    localStorage.setItem('current_survey', JSON.stringify(isExist));
                } else {
                    return false;
                }
            } else {
                return false;
            }
        });
    }

    deleteVision(vision_typeid, surveys) {
        let vision_id = '';
        const criteriasIds: Array<string> = [];
        const optionsIds: Array<string> = [];
        const title = this.surveyTypes.getTitle(vision_typeid);
        const survey = surveys.filter(x => x.title === title)[0];
        vision_id = survey.id;
        const criterias = survey.criterias;
        criterias.forEach(criteria => {
            criteriasIds.push(criteria.id);
            const options = criteria.options;
            options.forEach(option => {
                optionsIds.push(option.id);
            });
        });
        const subject = new Rx.ReplaySubject(3 /* buffer size */);
        if (optionsIds.length > 0) {
            subject.next(this.criteriaService.deleteOptions(optionsIds).subscribe(data => {  }));
            subject.next(this.deleteCriteriaAnswers(optionsIds));
            subject.next(this.criteriaService.deleteCriterias(criteriasIds).subscribe(data => {  }));
        }
        subject.next(this.visionService.deleteVision(vision_id).subscribe(data => {  }));

        return subject.map(() => {
            
        });
    }

    deleteCriteriaAnswers(optionsIds) {
        const answersIds: Array<string> = [];
        optionsIds.forEach(option => {
            this.jobService.getOptionAnswers(option).subscribe(data => {
                data.allAnswers.forEach(answer => {
                    const isExist = answersIds.filter(x => x === answer.id)[0];
                    if (!isExist) {
                        answersIds.push(answer.id);
                    }
                });
            });
        });
        if (optionsIds.length > 0) {
            if (answersIds.length > 0) {
                return this.criteriaService.deleteAnswers(answersIds).subscribe(result => {
                    return Observable.of(true);
                });
            } else {
                return Observable.of(false);
            }
        } else {
            return Observable.of(false);
        }
    }

    createNewVision(newSurveyTitle, user_id) {
        return this.visionService.getUserVisions(this.email).map(result => {
            this.user_data = result.User;
            if (this.user_data.surveys) {
                const isExist = this.user_data.surveys.filter(x => x.title === newSurveyTitle)[0];
                if (isExist) {
                    this.visionService.getVisionData(isExist.id).subscribe(resp1 => {
                        localStorage.setItem('current_survey', JSON.stringify(resp1.Survey));
                        return false;
                    });
                } else {
                    this.addNewVision(newSurveyTitle, user_id).subscribe(resp2 => {
                        return result; // true or false created
                    });
                }
            }
        });
    }

    addNewVision(newSurveyTitle, user_id) {
        const typeJobId = this.visionService.getTypeJobsId();
        return this.visionService.addNewVision(newSurveyTitle, this.email, user_id, typeJobId)
            .map(({ data }: any) => {
                localStorage.setItem('current_survey', JSON.stringify(data.createSurvey));
                localStorage.setItem('vision_title', newSurveyTitle);
                this.setSurveysInStorage(data.createSurvey);
                return true;
            },
            error => {
                return false;
            }
            );
    }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/models/vision.model.ts